export const CrimeType = {
  various_crime: "Various Crime",
  corruption_crime: "Corruption Crime",
  economic_crime: "Economic Crime",
};
export const IncidentDecisionType = {
  pending: "Pending",
  constitutes_offence: "Constitutes Crime Offence",
  does_not_constitute: "Does Not Constitute Crime Offence",
  not_under_authority: "Not Under the Authority of the Office",
};
export const ProsecutorDecisionType = {
  pending: "Pending",
  further_investigation: "Further Investigation",
  closure_of_investigation: "Closure of Investigation",
  decision_not_to_charge: "Decision Not to Charge",
  Frame_charge: "Frame Charge",
};
export const InvestigationFileStatus = {
  forward_to_coordinator: "Forward to Coordinator",
  assigned_to_prosecutor: "Assigned to Prosecutor",
  assigned_to_clerk: "Assigned to Clerk",
  forward_to_registrar: "Forward to Registrar",
  on_litigation: "On Litigation",
  final_verdict_given: "Final Verdict Given",
  on_appeal: "On Appeal",
  pending: "Pending",
  terminated: "Terminated",
  closed_by_prosecutor: "Closed by Prosecutor",
  further_investigation_requested: "Further Investigation Requested",
};
export const ProsecutorDecisionStatus = {
  pending: "Pending",
  approved: "Approved",
  revised: "Revised",
};
export const OpeniningCaseFileStatus = {
  Pending: "Pending",
  forwarded_to_registrar: "Forwarded to Registrar",
  forwarded_to_coordinator: "Forwarded to Coordinator",
  assigned_to_prosecutor: "Assigned to Prosecutor",
};
export const FurtherInvestigationDecision = {
  revised: "Revised",
  forward_to_coordinator: "Forward to Coordinator",
  back_coordinator: " Back Coordinator",
  forward_to_police: "Assigned to Police",
  assigned_to_clerk: "Assigned to Clerk",
  forward_to_registrar: "Forward to Registrar",
  back_to_registrar: "Back to Registrar",
  back_to_prosecutor: "Back to Prosector",
  pending: "Pending",
  revice: "Revise",
  approve: "Approve",
  rejected: "Rejected",
};
export const Roles = {
  director: "ProsecutionCaseDirector",
  coordinator: "ProsecutionCaseCoordinator",
  prosecutor: "ProsecutionCaseProsecutor", //InspectionProsecutor
  clerk: "ProsecutionCaseClerk",
  registrar: "ProsecutionCaseRegistrar",
  police: " ProsecutionCasePolice",
  // regionalOfficeOfCouncilHead: "RegionalOfficeOfCouncilHead",
  screeningTeamCoordinator: "ProsecutionCaseScreeningTeamCoordinator",
  externalPolice: "Police",
  externalPoliceCoordinator: "PoliceCoordinator",
  management: "ComplaintManagement ",
  complaintClerk: "ComplaintClerk",
  complaintRegistrar: "Registrar",
  complaintProsecutor: "ProsecutionCaseProsecutor", // "Prosecutor",
  ComplaintManagementProsecutor: "ComplaintManagementProsecutor",
  complaintCreator: "ComplaintCreator",
  mobileAppAdmin: "MobileAppAdmin",
};
export const InvestigationStatus = {
  Ongoing: "Ongoing",
  Completed: "Completed",
};
export const InvestigationStatus2 = {
  pending: "Pending",
  terminated: "Terminated",
  forwarded: "Forwarded",
  forwarded_to_cordinator: "Forwarded to Cordinator",
  forwarded_to_clerk: "Forwarded to clerk",
  forwared_to_police: "Forwarded to Police",
  sent_to_police: "Sent to Police",
  asigned_to_clerk: "Assigned to Clerk",
  back_to_cordinator: "Back to Cordinator",
};

export const IncidentStatus = {
  pending: "Pending",
  terminated: "Terminated",
  forwarded: "Forwarded",
  "forwarded to cordinator": "Forwarded to Cordinator",
  "forwarded to director": "Forwarded Director",
  "forwarded to screeingteam": "Forwarded to Screaning Team",
  forwared_to_police_cordinator: "Forwarded to Police Cordinator",
  forwarded_to_cordinator_cor: "Forwarded to Cordinator",
  "forwarded to registrar": "Forwarded to Registrar",
  sent_to_police: "Sent to Police",
  "forwarded to cordinatorforscreening": "Forwarded to Cordinator Screeing",
  "forwarded to cordinatorforscreeningadditional": "Forwarded to Cordinator",
};
export const CaseStatus = {
  Open: "Open",
  Closed: "Closed",
  Terminated: "Terminated",
  Under_Review: "Under Review",
};
export const ExternalUserRole = {
  police: "Police",
  police_coordinator: "Police Coordinator",
};
export const ReferenceType = {
  individual_incident: "Incident on Individual",
  public_incident: "Incident on Public",
};

export interface CrimeReferenceReceptionMethod {
  uu_id: number;
  reception_method: string;
  description: string;
}

interface VictimType {
  INDIVIDUAL: "individual";
  NON_GOVERNMENTAL: "non_governmental";
  GOVERNMENTAL: "governmental";
}
interface CrimeReferenceEvidence {
  uu_id: number;
  name: string;
}
interface CrimeOffenceExhibit {
  uu_id: number;
  name: string;
}
export const ScreeningOutcomeType = {
  approved: "Approved",
  rejected: "Rejected",
  further_investigation: "Further Investigation",
  forwarded_to_director: "Forwarded To Director",
};
export const CrimeLevel = {
  Heavy: "Heavy",
  Medium: "Medium",
  Light: "Light",
};
export const DefendantCaseStatus = {
  Pending: "Pending",
  Respond_Back_cordinator: "Respond Back Cordinator",
  investigation_recorded: "Investigation Recorded",
  Respond_Back_prosecutor: "Respond Back Prosecutor",
  Approved: "Approved",
  forwarded_to_director: "Forwarded to Director",
  forwarded_to_coordinator: "Forwarded to Coordinator",
  forwarded_to_registrar: "Forwarded to Registrar",
  sent_to_court: "Sent To Court",
};
export const DailyReportStatus = {
  Pending: "Pending",
  in_progress: "In Progress",
  scheduled: "Scheduled",
  decision_provided: "Decision Provided",
  pre_judgement_provided: "Pre-judgement Provided",
};
export interface Prosecutor {
  uu_id: number;
  full_name: string;
  work_level: string;
  working_id: string;
  email: string;
  phone_number: string;
  created_at: Date;
}
export interface Police {
  uu_id: number;
  full_name: string;
  work_level: string;
  badge_number: string;
  department: string;
  email: string;
  phone_number: string;
  created_at: Date;
}
export interface ScreeningTeamMember {
  id?: number;
  prosecutor_name: string;
  prosecutor_user_id: string;
  team_leader: boolean;
  crime_reference: CrimeReference | number;
}
export interface CrimeReference {
  is_efling: boolean;
  uu_id: number;
  crime_reference_number: string;
  date_received?: Date | null;
  crime_type?: keyof typeof CrimeType | null;
  reception_method?: CrimeReferenceReceptionMethod | null;
  reception_method_id?: number | null;
  category?: string | null;
  receiving_prosecutor?: string; // Prosecutor | number | null;
  receiving_prosecutor_id?: Prosecutor | null;
  receiving_police?: Police | number | null;
  receiving_police_id?: Police | null;
  description?: string | null;
  status: keyof typeof IncidentStatus;

  crime_incidence_time?: Date | null;
  crime_incident_narrative: string | null;
  victim_status: string | null;
  crime_category: string | null;
  evidence_written: string | null;
  tools_used: string | null;

  crime_incidence_region: string | null;
  crime_incidence_zone: string | null;
  crime_incidence_city: string | null;
  crime_incidence_woreda: string | null;
  crime_incidence_kebele: string | null;
  crime_incidence_site: string | null;

  screening_outcome: keyof typeof ScreeningOutcomeType | null;
  follow_up_action: string | null;
  decision_type: keyof typeof IncidentDecisionType | null;
  decision_date: Date | null;

  reporters?: Reporter[] | null;
  screening_team?: number[] | [];
  screening_members?: ScreeningTeamMember[] | [];
  screening_team_details?: Prosecutor[];
  victims?: Victim[] | null;
  suspects?: Suspect[] | null;
  witnesses?: Witness[] | null;
  Incident_Registration_number?: string | null;
  reference_type?: keyof typeof ReferenceType | null;
  asset_reference?: string | null;
  decision_details?: string | null;
  team_leader?: Prosecutor | null;
  team_leader_id?: number | null;
  crime_naretive_file?: string | File | null;
  screening_team_findings?: ScreeningFindings[];
  is_letter: boolean;
}
interface CrimeReferenceEvidence {
  uu_id: number;
  evidence_type: string;
  description: string;
  date_collected: Date;
  collected_by: string;
  document: string;
  crime_reference: CrimeReference;
}

interface CrimeReferenceExhibit {
  uu_id: number;
  tool_type: string;
  description: string;
  date_collected: Date;
  collected_by: string;
  document: string;
  crime_reference: CrimeReference;
}
export interface Suspect {
  uu_id: number;
  CR_number?: string | null;
  first_name?: string;
  middle_name?: string;
  last_name?: string;
  gender?: keyof typeof Gender | null;
  age?: number | null;
  education_level?: string | null;

  job_position?: string | null;
  ethnicity?: string | null;
  nationality?: string | null;
  religion?: string | null;
  date_of_birth: Date;
  phone_number?: string | null;
  email?: string | null;
  identity_card_number?: string | null;
  region?: string | null;
  zone?: string | null;
  woreda?: string | null;
  kebele?: string | null;
  house_number?: string | null;
  city?: string | null;

  criminal_record?: string | null;
  statement?: string | null;
  is_in_custody?: Boolean | null;
  investigation?: Investigation | number | null;

  picture?: string | File | null;
  picture_dms_uuid?: number | null;

  crimereference?: CrimeReference | number | null;
  Incident_Registration_number?: string | null;
}

export interface Victim {
  uu_id: number;
  CR_number?: string | null;
  investigation?: Investigation | number | null;
  first_name?: string;
  middle_name?: string;
  last_name?: string;
  gender?: keyof typeof Gender | null;
  age?: number | null;
  education_level?: string | null;

  job_position?: string | null;
  ethnicity?: string | null;
  nationality?: string | null;
  religion?: string | null;
  date_of_birth: Date;
  phone_number?: string | null;
  email?: string | null;
  identity_card_number?: string | null;
  region?: string | null;
  zone?: string | null;
  woreda?: string | null;
  kebele?: string | null;
  house_number?: string | null;
  city?: string | null;

  injury_details?: string | null;
  statement?: string | null;

  picture?: string | File | null;
  picture_dms_uuid?: number | null;

  crimereference?: CrimeReference | number | null;
  Incident_Registration_number?: string | null;
}

export interface Governmental {
  uu_id: number;
  governmental_type: string;
  office_name: string;
  department: string;
  address: string;
  CR_number?: string | null;
  investigation?: Investigation | number | null;
  crimereference?: CrimeReference | number | null;
}

export interface NonGovernmental {
  uu_id: number;
  organization_name: string;
  registration_number: string;
  non_governmental_type: string;
  address: string;
  CR_number?: string | null;
  investigation?: Investigation | number | null;
  crimereference?: CrimeReference | number | null;
}
interface Document {
  document_dms_uuid: string;
  file: string;
  id: number;
  uploaded_at: Date;
}
export interface Exhibit {
  uu_id: number;
  tool_type?: string;
  description?: string;
  date_collected?: Date;
  collected_by?: string;
  CR_number?: string | null;
  investigation?: Investigation | number | null;
  crimereference?: CrimeReference | number | null;
  Incident_Registration_number?: number | null;
  attachment_files?: string[] | File[] | [];
  attachment_details: Document[];
}
export interface Reporter {
  uu_id: number;
  first_name: string;
  middle_name: string;
  last_name: string;
  gender?: keyof typeof Gender | null;
  age?: number | null;
  education_level: string;
  job_position: string;
  ethnicity: string;
  nationality: string;
  religion: string;
  date_of_birth?: Date | null;
  phone_number: string;
  email: string;
  identity_card_number: string;
  region: string;
  zone: string;
  woreda: string;
  kebele: string;
  house_number: string;
  city: string;
  report_details: string;
  crimereference?: CrimeReference | null;

  picture?: string | File | null;
  picture_dms_uuid?: number | null;
}
export interface CrimeCategory {
  uu_id: number;
  crime_category_name: string;
  category_description: string;
}
export interface CrimeSubCategory {
  uu_id: number;
  crime_subcategory_name: string;
  subcategory_description: string;
  category_id: CrimeCategory;
}
export interface Investigation {
  uu_id: number;
  crime_reference?: CrimeReference | null;
  crime_reference_id?: CrimeReference | null;
  CR_number: string;
  crime_category?: CrimeSubCategory | null;
  crime_category_id?: CrimeSubCategory | number | null;
  investigation_status?: keyof typeof InvestigationStatus | null;
  status?: keyof typeof InvestigationStatus2 | null;
  prosecutor?: Prosecutor | null;
  prosecutor_id?: Prosecutor | null;
  police?: Police | null;
  police_id?: Police | null;
  assigned_team: "";
  start_date?: Date | null;
  end_date?: Date | null;
  description: string;
  investigation_result_naration: string;
  director_comments?: DirectorComment[] | [];
  coordinator_comments?: DirectorComment[] | [];

  Incident_Registration_number: string;
  asset_reference: "";
  crime_naretive_file?: string | File | null;
  investigation_result_naration_file?: string | File | null;

  ec_reference_result_file_upload?: string | File | null;
  ec_reference_result_file_details?: {
    dms_uuid: number;
    file_name: string;
    url: string;
  };
  ec_reference_result_file_dmsuuid?: string;
  ec_police_station_name?: string;
  ec_police_station_id?: string;
  sent_date_to_police?: Date;
  sent_back_to_cordinator?: Date;
  reciving_date?: Date;
}
export interface LoginAccount {
  access: string;
  access_token: string;
  refresh: string;
  refresh_token: string;
  type: "Main" | "Police";
  user_id: number;
  username: string;
  permissions: string[];
  roles: string[];
  email?: string;
  police_station_name: string | null;
  employee_id: number;
  admin_unit: number;
  org_unit: number;
  user_type: string;
  is_superuser: boolean;
  full_name: string;
  user?: ExternalPolice | null;
  structure?: Structure;
}
export interface DirectorComment {
  uu_id: number;
  comment: string;
  commented_at?: Date;
  investigation?: Investigation | number | null;
}
export interface CoordinatorComment {
  uu_id: number;
  comment: string;
  commented_at?: Date;
  investigation?: Investigation | number | null;
}
export interface PreliminaryInquiry {
  uu_id: number;
  prosecutor_registration_number: string;
  police_registration_number: string;
  reason_for_preliminary_inquiry: string;
  court_name: string;
  body_receiving_the_copy: string;
  inquiry_date?: Date;
  findings: string;
  investigation?: Investigation | number | null;
  applying_prosecutor?: string;
  witness_list?: Witness[] | [];
}
export interface PreliminaryInquiryWitness {
  uu_id: number;
  witness_info: number;
  preliminary_inquiry: number;
  witness_info_detail?: PreliminaryInquiry;
  their_statement?: string;
  createdAt?: Date;
}
export interface Schedule {
  uu_id: number;
  police_station_name: "";
  starting_date_time?: Date;
  end_date_time?: Date;
}
export const InvestigationFileBy = {
  oromia_case: "Regional Case",
  federal_case: "Federal Case",
};
export interface InvestigationFile {
  uu_id: number;
  id?: number;
  schedule_file_receiving_date?: Date;
  police_station_name: any;
  crime_reference_number: string;
  incident_registration_number: string;
  prosecutor_registration_number: string;
  assign_clerk: string;
  assign_prosecutor: string;
  receiving_date?: Date;
  status: keyof typeof InvestigationFileStatus | null;
  prosecutor_decision_type: keyof typeof ProsecutorDecisionType | null;
  prosecutor_decision_status: keyof typeof ProsecutorDecisionStatus | null;
  prosecutor_feedbacks?: ProsecutorDecisionFeedback[];

  police_station_id: any;
  is_efiling?: boolean;
  is_efiling_ec?: boolean;
  investigation_file_upload?: File | null | undefined;
  investigation_file_details?: { file_name: string; url: string };
  investigationfileby?: keyof typeof InvestigationFileBy | null;
}
export interface ProsecutorDecisionFeedback {
  uu_id: number;
  feedback_text: string;
  investigation_file: InvestigationFile | number;
}
export interface FurtherInvestigation {
  is_efiling?: boolean;
  uu_id: number;
  id: number;
  suspects_ids: Suspect[] | number[];
  suspects?: Suspect[] | [];
  crime_registration_number: string;
  prosecutor_registration_number: string;
  incident_registration_number: string;
  suspect_condition: string;
  file_submitted_by: string;
  reason_for_request: string;
  requesting_body: string;
  date_requested?: Date;
  coordinator_feedback?: string;
  date_approved?: Date;
  letter_number_sent?: string;
  date_sent_to_police?: Date;
  letter_number_received?: string;
  date_received_from_police?: Date;
  number_of_days_given?: number | null;
  decision?: keyof typeof FurtherInvestigationDecision;
  decision_reason?: string;
  by_letter?: Boolean;
  investigation_file?: InvestigationFile | number | null;
  feedbacks?: FurtherInvestigationFeedback[] | [];
  additional_investigation_file?: File | undefined;
  police_station_id?: string | null;
  police_station_name?: string | null;
}
export interface ScreeningFindings {
  uu_id: number;
  file: string | File | null;
  description?: string;
  crime_reference: CrimeReference | number | null;
  uploaded_at?: Date;
}
export interface CaseCreation {
  id: number;
  prosecutor_registration_number: string;
  date_sent_to_prosecutor?: Date;
  estimated_day_to_finish?: Date;
  status: keyof typeof CaseStatus | null;

  investigation_files?: InvestigationFile | number;

  incident_registration_no: string;
  crime_refernce_number: string;

  termination_status?: boolean;
  termination_reason?: string;
  termination_date?: Date;
}
export interface DefendantCaseDetail {
  id: number;
  defendants: Suspect[] | number[] | [];
  witness: Witness[] | number[];
  case?: CaseCreation | number;
  upload_charge_draft_upload?: File | null;
  upload_charge_draft_details?: {
    dms_uuid: number;
    file_name: string;
    url: string;
  };
  prosecutor_registration_number?: string;
  incident_registration_no?: string;
  crime_refernce_number?: string;
  crime_type?: string;
  crime_type_catagory?: string;
  crime_level?: keyof typeof CrimeLevel | null;
  articles_ofthe_charge?: string;
  upload_charge_draft?: File | null;
  uuid_dms_upload_charge_draft?: string | null;
  prosecutor_decision?: string | null;
  prosecutor_decision_description?: string | null;
  status: keyof typeof DefendantCaseStatus;
  coordinator_comments_detail?: DefendantCaseDetailCoordinatorComment[] | [];
  director_comments_detail?: DefendantCaseDetailDirectorComment[] | [];
}
export interface DefendantCaseDetailCoordinatorComment {
  id: number;
  comment: string;
  defendant_case_detail: DefendantCaseDetail | number;
  created_at?: Date;
}
export interface DefendantCaseDetailDirectorComment {
  id: number;
  comment: string;
  defendant_case_detail: DefendantCaseDetail | number;
  created_at?: Date;
}
export interface OpeniningCaseFile {
  id: number;
  defendant_case_detail?: DefendantCaseDetail | number;
  defendant_case_detail_info?: DefendantCaseDetail;
  defendants: Suspect[] | number[] | [];
  defendants_info?: Suspect[];
  status: keyof typeof OpeniningCaseFileStatus;
  assign_prosecutor: string;
  userid_assign_prosecutor?: string;
  prosecutor_registration_number: string;
  incident_registration_no: string;
  crime_refernce_number: string;
  court_type: string;
  court_level: string;
  court_registration_number: string;
  court_hearing_place: string;
  zone: string;
  city: string;
  sub_city: string;
  woreda: string;
  first_court_hearing_date: Date;
  reassign_prosecutor: string;
}
export interface DailyReport {
  id: number;
  opening_case_file: OpeniningCaseFile | number;
  defendants: Suspect[] | number[] | [];
  defendants_info?: Suspect[];
  status: keyof typeof DailyReportStatus | null;
  prosecutor_registration_number: string;
  incident_registration_no: string;
  crime_refernce_number: string;
  court_registration_number: string;
  next_trial_appointment: Date | null;
  appointment_type: string;
  appointment_reason: string;
  dailyreport_summary: string;
  court_order_for_next_appointment: string;
  is_final_verdict_given: boolean;
}
export interface CourtDecision {
  id?: number;
  court_decision: string;
}
export interface CourtDecisionType {
  id?: number;
  court_decision: string;
}
export interface FinalVerdict {
  id: number;
  opening_case_file: OpeniningCaseFile | number;
  defendants: Suspect[] | number[] | [];
  defendants_info?: Suspect[];
  prosecutor_registration_number: string;
  incident_registration_no: string;
  crime_refernce_number: string;
  court_registration_number: string;
  court_decision: CourtDecision | string;
  court_decision_amount: string;
  prosecutor_feedback_on_decision: string;
  court_decision_summary?: string;
  court_decision_type?: CourtDecisionType | string;
}
export interface CoordinatorCommentsOnDailyReport {
  id?: number;
  comment: string;
  daily_report: DailyReport | number;
  created_at?: Date;
}
export interface CrimeTypeBaseData {
  id?: number;
  name: string;
}
export interface CrimeCategoryBaseData {
  id?: number;
  name: string;
  crime_type: number;
}
export interface CrimeLevelBaseData {
  id?: number;
  level: string;
}
export interface CaseTerminationReasonBaseData {
  id?: number;
  reason: string;
}
export interface ProsecutorDecisionBaseData {
  id?: number;
  decision: string;
}
export interface CourtTypeBaseData {
  id?: number;
  type: string;
}
export interface CourtLevelBaseData {
  id?: number;
  level: string;
}
export interface AppointmentTypeBaseData {
  id?: number;
  appointment_type: string;
}
export interface ScreeningOutcomeBaseData {
  id?: number;
  outcome: string;
}
export interface AmendedDecisionBaseData {
  id?: number;
  decision: string;
}
export interface AmendedPunishmentBaseData {
  id?: number;
  punishment: string;
}
export interface ExternalPolice {
  id?: number;
  title: string;
  full_name: string;
  police_id_number: string | PoliceStation;
  police_station: string | PoliceStation;
  station_address: string;
  phone_number: string;
  username: string;
  email: string;
  police_station_id: any;
  role: keyof typeof ExternalUserRole | null;
  password: string;
  police_station_name?: string;
  confirm_password?: string;
  assigned_by_id: string;
}
export interface FurtherInvestigationFeedback {
  id?: number;
  feedback_text: string;
  created_by?: string;
  investigation_request: FurtherInvestigation | number | null;
}
export interface PoliceStation {
  id?: number;
  name: "";
  address: "";
  region: "";
  zone: "";
  woreda: "";
  kebele: "";
  house_number: "";
  city: "";
}
export const BailRightStatus = {
  submitted: "Submitted to Registrar",
  forwarded_to_coordinator: "Forwarded to Coordinator",
  assigned_to_prosecutor: "Assigned to Prosecutor",
  prosecutor_responded: "Prosecutor Responded",
  forwarded_to_registrar: "Forwarded to Registrar",
  bail_litigation: "Bail Litigation",
  bail_granted: "Bail Granted",
  bail_rejected: "Bail Rejected",
};
export const BailRightType = {
  on_court_hearing: "On Court Hearing",
  on_investigation: "On Investigation",
};
export interface BailRight {
  uu_id?: number;
  suspect: number | null;
  suspect_info?: Suspect | null;
  court_bail_application_file_upload?: File | null;
  prosecutor_document_upload?: File | null;
  receipt_of_payment_upload?: File | null;
  status: keyof typeof BailRightStatus;
  crime_registration_number?: string;
  incident_registration_number?: string;
  prosecutor_registration_number?: string;
  suspect_fullname?: string;
  court_bail_application_file?: File | null;
  court_registration_number?: string;
  bail_amount: number;
  bail_evidence_description?: string;
  court_name?: string;
  court_open_day?: Date | null;
  court_hearing_date?: Date | null;
  reference_number?: string;
  coordinator_assigned_prosecutor?: string;
  userid_coordinator_assigned_prosecutor?: string;
  coordinator_approved_recommendation?: "approve" | "respond_back";
  prosecutor_summary?: string;
  prosecutor_document?: File | null;
  bail_type?: keyof typeof BailRightType;
  daily_hearing_detail?: string;

  appointment_date?: Date | null;
  appointment_reason?: string;
  court_hearing?: string;
  court_order?: string;
  decision_action?: "grant" | "not_grant" | "pending";
  bail_stance?: "favored" | "opposed";
  final_outcome?: "approved" | "rejected";
  prosecutor_feedback?: string;
  to_appeal?: boolean;
  receipt_of_payment?: File | null;
  coordinator_feedbacks?: BailRightFeedback[];
  assign_prosecutor?: string;
  assign_prosecutor_userid?: string;
}
export interface BailRightFeedback {
  uu_id?: number;
  coordinator_user_id: number | string;
  coordinator_fullname: string;
  comment: string;
  decision: "approve" | "respond_back";
  created_at?: Date;
  bail_right: number;
}
export interface BailHearingDecision {
  uu_id?: number;
  receipt_of_payment_upload?: File | null;
  receipt_of_payment_details?: { file_name: string; url: string };
  daily_hearing_detail?: string;
  if_final_decision_given: boolean;
  bail_right: BailRight | number | null;

  appointment_date?: Date | string | null;
  appointment_reason?: string;
  court_hearing?: string;
  court_order?: string;
  decision_action?: "grant" | "not_grant" | "pending";
  bail_stance?: "favored" | "opposed";
  final_outcome?: "approved" | "rejected";
  prosecutor_feedback?: string;
  to_appeal?: boolean;
  receipt_of_payment?: File | null;
  assign_prosecutor?: string;
  assign_prosecutor_userid?: string;
}
// =========================================================================
export interface ComplaintReception {
  id?: number;

  witness_info?: Witness[] | [];
  evidence_info?: Evidence[] | [];
  power_of_agency_info_detail?: PowerOfAgency[] | [];
  resolution_info?: Resolutions[] | [];

  user_id?: string;
  clerk_name?: string;
  clerk_user_id?: string;
  manager_name?: string;
  manager_user_id?: string;
  incident_admin_unit_id?: string; //clerk
  incident_admin_unit_name?: string; //fetch from admin_unit_detail:
  incident_org_unit_id?: string; //clerk

  admin_unit_id?: string; //clerk
  org_unit_id?: string; //clerk

  departement_id?: string; //select from departments_by_admin_unit:
  unit_name?: string; //selected department unit name
  service_place_region?: string;
  service_place_zone_or_city?: string;
  service_place_woreda_or_kebele?: string;
  is_appeal?: boolean; //always true
  client_full_name?: string;
  gender?: keyof typeof Gender;
  region?: string;
  zone_or_city?: string;
  woreda_or_kebele?: string;
  phone_number?: string;
  email?: string;
  nationality?: string;
  client_id?: string;
  complaint_type?: keyof typeof ComplaintType;
  complaint_reception_date?: Date;
  incident_date?: Date;
  accused_person_name?: string;
  accused_department?: string;
  complaint_summary?: string;
  requested_resolution?: string;
  status?: keyof typeof ComplaintStatus;

  forwarding_history?: {
    id: number;
    resolution_info: {
      id: number;
      decision_type: string;
      resolved_by: string;
      resolved_by_user_id: number;
      appointment_date: string;
    };
    from_status: string;
    to_status: string;
    forwarded_by: string;
    forwarded_to: number;
    admin_unit_id: number;
    org_unit_id: number;
    note: string;
    forwarded_at: string;
    complaint: string;
    resolution_process: number;
  }[];

  created_at?: Date;
  updated_at?: Date;

  sub_city?: string;
  kebele?: string;
  house_number?: string;

  application_number?: string;
  is_complaint_not_by_mobile?: boolean;
}
export const AccusedDepartment = {
  Prosecution: "Prosecution Case Department",
  Civil: "Civil Case Department",
  DRAL: "DRAL",
  "Asset Recovery": "Asset Recovery",
};
export const Gender = {
  male: "Male",
  female: "Female",
};
export const ComplaintType = {
  new: "New Complaint",
  appeal: "Appeal",
};
export const ComplaintStatus = {
  pending: "Pending",
  forwarded_to_management: "Forwarded to Management",
  under_review: "Under Review",
  on_appointment: "On Appointment",
  resolved: "Resolved",
  closed: "Closed",
  appealed: "Appealed",
  forwarded_to_registrar: "Forwarded to Registrar",
};
export interface Witness {
  id?: number;
  full_name?: string;
  gender: keyof typeof Gender;
  region?: string;
  zone_or_city?: string;
  woreda_or_kebele?: string;
  phone_number?: string;
  email?: string;
  complaint?: ComplaintReception | number;
  created_at?: Date;

  sub_city?: string;
  kebele?: string;
  house_number?: string;
}
export interface Evidence {
  id?: number;
  attachment?: File | null;
  description?: string;
  complaint?: ComplaintReception | number;
  attachment_details?: {
    file_name: string;
    url: string;
  };
  created_at?: Date;
  uploaded_files: DocumentSchema[];
}
export interface DocumentSchema {
  uu_id: string;
  document_type: string;
  document_uuid: string;
  document_path: string;
  created_at: string;
  updated_at: string;
  reporter: string;
}
export interface PowerOfAgency {
  id?: number;
  name?: string;
  region?: string;
  zone_or_city?: string;
  woreda_or_kebele?: string;
  phone_number?: string;
  email?: string;
  complaint?: ComplaintReception | number;
  created_at?: Date;

  sub_city?: string;
  kebele?: string;
  house_number?: string;
}
export const ResolutionDecisionType = {
  forward_to_higher_authority: "Forward to higher authority",
  resolved: "Resolved",
  further_review: "Further review",
  forward_to_lower_authority: "Forward to lower authority",
  forwarded: "Transfered",
  close: "Close",
};
export interface Resolutions {
  id?: number;
  complaint_id?: ComplaintReception | number;
  appealed_complaint_id?: Appeal | number;
  decision_document?: File | null;
  decision_type?: keyof typeof ResolutionDecisionType;
  decision_summary?: string;
  appointment_reason?: string;
  appointment_date?: Date;
  resolved_by?: string;
  resolved_by_user_id?: string;
  complaint?: ComplaintReception | number;
  appealed_complaint?: Appeal | number;
  attachment_details?: {
    file_name: string;
    url: string;
  };

  registration_number?: string;
  registration_date?: Date;
  updated_at?: Date;

  admin_unit_id?: string;
  org_unit_id?: string;

  uploaded_documents?: DocumentSchema[];
  created_at?: Date;
}
export interface Appeal {
  id?: number;
  complaint_id?: ComplaintReception | number;
  parent_appeal_id?: Appeal | number;
  appeal_document?: File | null;
  resolution_file?: File | null;
  status?: keyof typeof AppealStatus;
  appeal_date?: Date;
  lower_org_unit?: string;
  lower_admin_unit?: string;
  appeal_summary?: string;
  resolution_text?: string;
  resolution_date?: Date;
  resolved_by?: string;
  resolved_by_user_id?: string;
  admin_unit_id?: string;
  org_unit_id?: string;
  departement_id: string;
  complaint?: ComplaintReception | number;
  parent_appeal?: Appeal | number;
  complaint_info?: ComplaintReception | CivilCaseComplaint;
  parent_appeal_info?: {
    appeal_date: Date;
    appeal_summary: string;
    id: number;
  };
  child_appeals_info?: [
    {
      appeal_date: Date;
      appeal_summary: string;
      id: number;
    },
  ];
  resolution_info?: Resolutions[];
  is_appealed?: boolean;
  registration_date?: Date;
  uploaded_files?: DocumentSchema[];
  created_at?: Date;
  updated_at?: Date;

  application_number?: string;
  appeal_application_number?: string;
  is_attorney_appeal_request?: boolean;
}
export const AppealStatus = {
  pending: "Pending",
  forwarded_to_management: "Forwarded to Management",
  on_appointment: "On Appointment",
  resolved: "Resolved",
  closed: "Closed",
  appealed: "Appealed",
  forwarded_to_registrar: "Forwarded to Registrar",
};
export interface Feedback {
  id: number;
  feedback_number?: string;
  service_application_number?: string;
  user: string;
  message: string;
  rating: number;
  created_at: Date;
  updated_at: Date;
}

export interface User {
  id: number;
  email: string;
  full_name: string;
  is_active: boolean;
  role: null;
}

export interface AdminUnitDetail {
  uu_id: number;
  hierarchy_level: {
    uu_id: number;
    name: string;
    display_name: string;
  };
  unit_name: string;
  structure_level: string;
  is_regiometropolitan: boolean;
  is_branch: boolean;
  description: string;
  parent_unit: string;
  branch_unit: null;
}

export interface AdminUnitDepartments {
  message: string;
  tree: { uu_id: number; unit_name: string }[];
}

export interface ChildOrgUnit {
  message: string;
  tree: {
    uu_id: number;
    unit_name: string;
    description: string;
    structure_level: string;
    hierarchy_level: string;
    parent: number;
    children: [
      {
        uu_id: number;
        unit_name: string;
        description: string;
        structure_level: string;
        hierarchy_level: string;
        parent: number;
        children: [];
      },
    ];
  };
}

export interface Structure {
  admin_unit?: {
    uu_id: string;
    hierarchy_level: {
      uu_id: number;
      name: string;
      display_name: string;
    };
    unit_name: string;
    structure_level: string;
    is_regiometropolitan: boolean;
    is_branch: boolean;
    description: string;
    parent_unit: number;
    branch_unit: null;
  };
  org_unit: {
    uu_id?: number;
    hierarchy_level?: {
      uu_id?: number;
      name?: string;
      display_name?: string;
    };
    unit_name?: string;
    structure_level?: string;
    description?: string;
    is_vacant?: boolean;
    is_open?: boolean;
    parent_unit?: number;
  };
  child_org_units?: {
    message?: string;
    tree?: {
      uu_id?: number;
      unit_name?: string;
      description?: string;
      structure_level?: string;
      hierarchy_level?: string;
      parent?: number;
      children: {
        uu_id: number;
        unit_name: string;
        description: string;
        structure_level: string;
        hierarchy_level: string;
        parent: number;
        children: [];
      }[];
    };
  };
  child_admin_units?: {
    message?: string;
    units: {
      unit_name: string;
      description: string;
      uu_id: string;
      hierarchy_level: string;
      structure_level: string;
      is_regiometropolitan: boolean;
    }[];
  };
  departments: {
    message: string;
    tree: { uu_id: number; unit_name: string }[];
  };
  hierarchy?: {
    current?: {
      uu_id?: number;
      hierarchy_level?: {
        uu_id?: number;
        name?: string;
        display_name?: string;
      };
      unit_name?: string;
      structure_level?: string;
      description?: string;
      is_vacant?: boolean;
      is_open?: boolean;
      parent_unit: number;
    };
    parent_chain: [];
  };
}
export interface CivilCaseComplaint {
  id?: number;
  witness_info?: CivilCaseWitness[] | [];
  evidence_info?: CivilCaseEvidence[] | [];
  power_of_agency_info_detail?: CivilCasePowerOfAgency[] | [];
  resolutions?: CivilCaseResolutions[] | [];
  appeal_info?: CivilCaseAppeald[] | [];

  client_id?: string;
  user_id?: string;
  clerk_name?: string;
  clerk_user_id?: string;
  admin_unit_id?: string;
  org_unit_id?: string;
  departement_id?: string;
  unit_name?: string;
  service_place_region?: string;
  service_place_zone_or_city?: string;
  service_place_woreda_or_kebele?: string;
  is_appeal?: boolean;
  is_prosecution_case?: boolean;
  is_civil_case?: boolean;
  is_hrms_case?: boolean;
  is_asset_recovery_case?: boolean;
  client_full_name?: string;
  gender?: keyof typeof Gender;
  region?: string;
  zone_or_city?: string;
  woreda_or_kebele?: string;
  phone_number?: string;
  email?: string;
  nationality?: string;
  complaint_type?: keyof typeof ComplaintType;
  complaint_reception_date?: Date;
  incident_date?: Date;
  accused_person_name?: string;
  accused_department?: keyof typeof AccusedDepartment;
  complaint_summary?: string;
  requested_resolution?: string;
  case_registration_number?: string;
  status?: keyof typeof CivilCaseComplaintStatus;
  assgined_prosecutor?: string;
  user_id_assgined_prosecutor?: string;
  created_at?: Date;
  updated_at?: Date;
  registration_number?: string;
  registration_date?: Date;

  sub_city?: string;
  kebele?: string;
  house_number?: string;

  application_number?: string;
  is_complaint_not_by_mobile?: boolean;

  cordinator_name?: string;
  user_id_cordinator?: string;
}
export const CivilCaseComplaintStatus = {
  pending: "Pending",
  forwarded_to_cordinator: "Forwarded to Cordinator",
  assigned_to_prosecutor: "Assigned To Prosecutor",
  under_review: "Under Review",
  forwarded_to_registrar: "Forwarded to Registrar",
  on_appointment: "On Appointment",
  resolved: "Resolved",
  closed: "Closed",
  appealed: "Appealed",
};
export interface CivilCaseWitness {
  id?: number;
  full_name?: string;
  gender?: keyof typeof Gender;
  region?: string;
  zone_or_city?: string;
  woreda_or_kebele?: string;
  phone_number?: string;
  email?: string;
  created_at?: Date;
  updated_at?: Date;
  complaint?: CivilCaseComplaint | number;

  sub_city?: string;
  kebele?: string;
  house_number?: string;
}
export interface CivilCaseEvidence {
  id?: number;
  attachment?: File | string | null;
  attachment_details?: {
    file_name: string;
    url: string;
  };
  description?: string;
  created_at?: Date;
  updated_at?: Date;
  complaint?: CivilCaseComplaint | number;

  uploaded_files?: DocumentSchema[];
}
export interface CivilCasePowerOfAgency {
  id?: number;
  name?: string;
  region?: string;
  zone_or_city?: string;
  woreda_or_kebele?: string;
  phone_number?: string;
  email?: string;
  complaint?: CivilCaseComplaint | number;

  sub_city: "";
  kebele: "";
  house_number: "";
}
export interface CivilCaseResolutions {
  id?: number;
  complaint_id?: CivilCaseComplaint | number;
  appealed_complaint_id?: Appeal | number;
  decision_document?: File | string | null;
  amended_decision_document?: File | null;
  decision_document_details?: {
    file_name: string;
    url: string;
  };
  user_id?: string;
  client_id?: string;
  decision_type?: keyof typeof CivilCaseResolutionDecisionType;
  decision_summary?: string;
  appointment_reason?: string;
  appointment_date?: Date;
  resolved_by?: string;
  resolved_by_user_id?: string;
  s_escalated?: boolean;
  amended_decision_summary?: string;
  amended_by_role?: keyof typeof CivilCaseAmmendedBy;
  amended_by_user_id?: string;
  admin_unit_id?: string;
  org_unit_id?: string;
  complaint?: CivilCaseComplaint | number;
  appealed_complaint?: CivilCaseAppeald | number;
  amended_from?: CivilCaseResolutions | number;
  created_at?: Date;
  updated_at?: Date;

  registration_number?: string;
  registration_date?: Date;

  uploaded_documents?: DocumentSchema[];
  amended_documents?: DocumentSchema[];
  feedbacks?: CivilCaseResolutionsFeedback[] | [];
}
export interface CivilCaseResolutionsFeedback {
  id?: number;
  resolution_id?: CivilCaseResolutions | number;
  given_by_role?: keyof typeof CivilCaseAmmendedBy;
  feedback_type?: keyof typeof CivilCaseResolutionsFeedbackType;
  summary?: string;
  feedback_document?: File | string | null;
  given_by_user_id?: string;
  resolution?: CivilCaseResolutions | number;
  created_at?: Date;
}
export const CivilCaseResolutionDecisionType = {
  escalate_to_higher_authority: "Escalte to higher authority",
  resolved: "Resolved",
  further_review: "Further review",
  forward_to_lower_authority: "Forward to lower authority",
  close: "Close",
  on_panel: "On Panel",
  assign_prosecutor: "Assign Prosecutor",
  forwarded: "Transfer",
};
export const CivilCaseAmmendedBy = {
  coordinator: "Coordinator",
  director: "Director",
  deputy: "Deputy",
  general_attorney: "General Attorney",
  prosecutor: "Prosecutor",
};
export const CivilCaseResolutionsFeedbackType = {
  approve: "Approve",
  respond_back: "Respond Back",
};
export interface CivilCaseAppeald {
  id?: number;
  complaint_id?: CivilCaseComplaint | number;
  parent_appeal_id?: CivilCaseAppeald | number;
  appeal_document?: File | string | null;
  resolution_file?: File | string | null;
  status?: keyof typeof CivilCaseAppealdComplaintStatus;
  user_id?: string;
  client_id?: string;
  appeal_date?: Date;
  lower_org_unit?: string;
  lower_admin_unit?: string;
  appeal_summary?: string;
  resolution_text?: string;
  resolution_date?: Date;
  resolved_by?: string;
  resolved_by_user_id?: string;
  assgined_prosecutor?: string;
  user_id_assgined_prosecutor?: string;
  admin_unit_id?: string;
  org_unit_id?: string;
  departement_id?: string;
  unit_name?: string;
  service_place_region?: string;
  service_place_zone_or_city?: string;
  service_place_woreda_or_kebele?: string;
  complaint?: CivilCaseComplaint | number;
  parent_appeal?: CivilCaseAppeald | number;
  complaint_info?: CivilCaseComplaint;
  resolution_files?: DocumentSchema[];
  resolutions?: CivilCaseResolutions[] | [];
  is_appealed?: boolean;
  parent_appeal_info?: CivilCaseAppeald;
  child_appeals_info?: CivilCaseAppeald[];
  uploaded_files?: DocumentSchema[];
  registration_date?: Date;
  registration_number?: string;
  application_number?: string;
  appeal_application_number?: string;
}
export const CivilCaseAppealdComplaintStatus = {
  pending: "Pending",
  forwarded_to_management: "Forwarded to Management",
  forwarded_to_registrar: "Forwarded to Registrar",
  on_appointment: "On Appointment",
  resolved: "Resolved",
  closed: "Closed",
  appealed: "Appealed",
};

export const FILE_URL = {
  EVIDENCE: "/complaint_entity/evidence-files/document/",
  CIVIL_EVIDENCE: "complaint_handling/evidence-files/document/",
  RESOLUTION_PROCESS: "/complaint_entity/resolution-documents/document/",
  CIVIL_RESOLUTION_PROCESS:
    "/complaint_handling/appeal-resolution-files/document/document/",
  APPEAL: "/complaint_entity/appeal-files/document/",
};
